import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { HeroWrapper, Background, HeroContent, HeroContentWrapper, HeroTitle, HeroSubTitle } from './styles';
import {
  HeroWrapperNew,
  BackgroundNew,
  HeroContentNew,
  HeroContentNewInner,
  HeroContentNewInnerText,
  HeroContentNewInnerScaledText,
  HeroTitleNew,
  HeroSubTitleNew,
} from './newStyles';

interface HeroType {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  background?: any;
  fullWidth?: boolean;
  hasMargin?: boolean;
  height?: string;
  contentPosition?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'center-left'
    | 'center-center'
    | 'center-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

interface HeroTypeNew {
  title?: string;
  subTitle?: string;
  background?: any;
}
export const Hero: React.FunctionComponent<HeroType> = ({
  title = '',
  subTitle = '',
  background,
  height = '330px',
  fullWidth,
  children,
  hasMargin = false,
  contentPosition = 'center-center',
}) => {
  return (
    <HeroWrapper height={height} fullWidth={fullWidth} contentPosition={contentPosition} hasMargin={hasMargin}>
      <Background>
        <GatsbyImage image={background.childImageSharp.gatsbyImageData} loading={'eager'} alt="" />
      </Background>
      <HeroContentWrapper contentPosition={contentPosition}>
        <HeroContent contentPosition={contentPosition}>
          {children || (
            <React.Fragment>
              {title ? <HeroTitle>{title}</HeroTitle> : null}
              {subTitle ? <HeroSubTitle>{subTitle}</HeroSubTitle> : null}
            </React.Fragment>
          )}
        </HeroContent>
      </HeroContentWrapper>
    </HeroWrapper>
  );
};
